import ImageWithFallback from "components/ImageWithFallback";
import Rating from "components/Rating";
import {Button} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {regular, solid} from "@fortawesome/fontawesome-svg-core/import.macro";

export default function ReviewCard({review, location}) {

  return (
    <div className={"rounded shadow-md mb-4 last:mb-0"}>
      <div className="p-3 !pb-0 flex items-start">
        <div className="mr-4 shrink-0 relative w-20 border after:pb-[100%] after:content-[''] after:block">
          <ImageWithFallback
            className={"absolute object-contain"}
            src={review.user.avatar_url}
            alt={review.user.displayName}
          />
        </div>
        <div className="grow">
          <h5 className="font-bold">
            {review.user.display_name}
          </h5>
          <div className="my-1 text-xs text-gray-500">
            3 days ago
          </div>
          <div className="flex flex-nowrap items-center mb-2">
            <Rating
              value={review.rating || 5}
              precision={0.5}
              readOnly
              className={'mr-2'}
            />
            <div className="text-xs text-gray-500">
              {review.rating.toFixed(1)}
            </div>
          </div>
        </div>
      </div>
      <div className="p-3 border-b">
        <h5 className="font-bold">
          {review.title}
        </h5>
        <p className={"text-sm"}>{review.body}</p>
      </div>
      <div className="px-3 flex gap-4">
        <Button variant="text" className={"text-gray-500 hover:bg-transparent hover:text-primary"}>
          {
            review.was_helpful
              ? <FontAwesomeIcon icon={solid('thumbs-up')} className={"mr-2 text-primary"}/>
              : <FontAwesomeIcon icon={regular('thumbs-up')} className={"mr-2"}/>
          }
          Helpful
          {review.helpful_count ? ` (${review.helpful_count})` : ''}
        </Button>
        <Button variant="text" className={"text-gray-500 hover:bg-transparent hover:text-primary"}>
          {
            review.was_reported
              ? <FontAwesomeIcon icon={solid('flag')} className={"mr-2 text-primary"}/>
              : <FontAwesomeIcon icon={regular('flag')} className={"mr-2"}/>
          }
          Report
          {review.reported_count ? ` (${review.reported_count})` : ''}
        </Button>
      </div>
      {
        review.owner_reply_text &&
        <>
          <div className="border-t p-3 !pb-0 flex items-start">
            <div className="mr-4 shrink-0 relative w-20 border after:pb-[100%] after:content-[''] after:block">
              <ImageWithFallback
                className={"absolute object-contain"}
                src={location.avatar_url}
                alt={location.name}
              />
            </div>
            <div className="grow">
              <h5 className="font-bold">
                {location.name}
              </h5>
              <div className="my-1 text-xs text-gray-500">
                {location.city}, {' '}{location.region}
              </div>
            </div>
          </div>
          <div className="p-3 !pb-0">
            <p className={"text-sm"}>{review.owner_reply_text}</p>
          </div>
          <div className="p-3 flex items-center">
            <FontAwesomeIcon icon={solid('certificate')} className={"text-primary mr-2"}/>
            <span className="text-gray-500 text-sm">OFFICIAL RESPONSE</span>
            <span className="ml-auto text-xs text-gray-500">1 day ago</span>
          </div>
        </>
      }
    </div>
  )
}
